module.exports = __webpack_public_path__ + "img/header-title.3f37cbcd.png";